import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileCheck2, Loader2, ExternalLink } from "lucide-react";
import { billingApi, API } from "@/lib/api-client";

export default function EvidenceVault() {
  const [data, setData] = useState(null);

  useEffect(() => {
    billingApi.evidence().then(setData).catch(() => setData({ count: 0, evidence: [] }));
  }, []);

  return (
    <div className="min-h-screen uc-grain relative" data-testid="evidence-vault-page">
      <div className="max-w-5xl mx-auto px-6 py-8">
        <div className="flex items-center gap-4 mb-8">
          <Link to="/" className="uc-chip flex items-center gap-1.5 hover:bg-white/5" data-testid="evidence-back-btn">
            <ArrowLeft size={11} /> Dashboard
          </Link>
          <div>
            <div className="font-mono-uc text-[9px] uppercase tracking-[0.3em] text-emerald-300/80">PROOF OF DELIVERY</div>
            <h1 className="text-2xl font-semibold text-white">Evidence Vault</h1>
          </div>
        </div>

        {!data ? (
          <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" /></div>
        ) : data.count === 0 ? (
          <div className="border border-white/10 bg-black/30 p-10 text-center text-white/50 text-sm" data-testid="evidence-empty">
            No completed mandates with artifacts yet. Every mandate that closes will file its
            verifiable artifact here — PDF, transaction receipt, live URL, or sealed record.
          </div>
        ) : (
          <div className="space-y-3" data-testid="evidence-list">
            {data.evidence.map((e) => (
              <div key={e.mandate_id} className="border border-white/10 bg-black/40 p-4 flex flex-wrap items-center justify-between gap-3"
                data-testid={`evidence-row-${e.mandate_id}`}>
                <div className="flex items-start gap-3 min-w-0">
                  <FileCheck2 size={16} className="text-emerald-300 mt-0.5 shrink-0" />
                  <div className="min-w-0">
                    <div className="text-sm text-white truncate">{e.title}</div>
                    <div className="font-mono-uc text-[10px] text-white/40 uppercase">
                      agent: <span className="text-amber-400">{e.agent}</span>
                      {" · "}completed: {e.completed_at ? new Date(e.completed_at).toLocaleString() : "—"}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="uc-chip font-mono-uc text-[9px] uppercase text-white/60">{e.artifact_kind}</span>
                  {e.artifact_ref && (e.artifact_ref.startsWith("http") || e.artifact_ref.startsWith("/api/")) ? (
                    <a href={e.artifact_ref.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${e.artifact_ref}` : e.artifact_ref}
                      target="_blank" rel="noreferrer"
                      className="uc-chip text-emerald-300 hover:bg-emerald-500/10 flex items-center gap-1.5"
                      data-testid={`artifact-link-${e.mandate_id}`}>
                      <ExternalLink size={10} /> Artifact
                    </a>
                  ) : (
                    <span className="font-mono-uc text-[10px] text-emerald-300/80 max-w-[200px] truncate"
                      data-testid={`artifact-ref-${e.mandate_id}`}>{e.artifact_ref}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
